import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { OfferListTableOffer, TicketOfferListTableDataColumnType } from "../../../Types/Application/Ecommerce/Ecommerce";
import api from "../../../utils/api";
import Swal from "sweetalert2";

export const offerListTableData = [
  {
    offer_title: "Hurry Up!",
    offer_type: "amount",
    offer_discount: 100.00,
    offer_status: "Active",
    originalPrice: 500.00,
    
  },
  {
    offer_title: "For Kids",
    offer_type: "amount",
    offer_discount: 100.00,
    offer_status: "Active",
    originalPrice: 500.00,
  },
];

// const OfferListTableAction = () => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
  // Your delete logic here (API call, state update, etc.)
  // console.log("Deleting ID:", id);
  try {
    await api.delete(`/api/OfferPlan/DeleteOfferPlan)?offerPlanId=${id}`);
    Swal.fire('Deleted!', 'Offer has been deleted.', 'success');

    // Optional: refresh the list
    // setTicketListTableDatas((prev) => prev.filter((item) => item.adultPlanId !== id));
  } catch (error) {
    Swal.fire('Error!', 'Failed to delete the offer.', 'error');
    console.error("Delete error:", error);
  }
};

interface ProductListTableActionProps {
  offerPlanId: any;
  onDelete: (id: number) => void;
}

export const OfferListTableAction: React.FC<ProductListTableActionProps> = ({ offerPlanId, onDelete }) => {
  const editUrl = `/offer/edit/${offerPlanId}`;

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this offer!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(offerPlanId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <Link to={editUrl}>
        <SVG iconId="edit-content" style={{ fill: 'blue' }} />
      </Link>
      <button className="btn btn-sm" onClick={handleDeleteClick}>
        <SVG iconId="trash1" style={{ fill: 'red' }} />
      </button>
    </div>
  );
};


export const OfferListTableOfferComponent: React.FC<OfferListTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const OfferListTableStatus :React.FC<OfferListTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export const offerListTableDataColumn: TableColumn<TicketOfferListTableDataColumnType>[] = [
  {
    name: "Offer Name",
    cell: (row) => <OfferListTableOfferComponent title={row.offerName}/>,
    sortable: true,
    grow: 2,
  },
  {
    name: "Free Type",
    selector: (row) => `${row.freeType}`,
    sortable: true,
  },
  {
    name: "No. of Adults",
    selector: (row) => `${row.adultBuy}`,
    sortable: true,
  },
  {
    name: "No. of Child",
    selector: (row) => `${row.childBuy}`,
    sortable: true,
  },
  {
    name: "Total Free",
    selector: (row) => `${row.totalFree}`,
    sortable: true,
    },
    {
    name: "Total Tickets",
    selector: (row) => `${row.totalCount}`,
    sortable: true,
    },
  {
    name: "Offer Status",
    cell: (row) =>  <OfferListTableStatus title={row.isOfferActive} />,
  },
  {
    name: "Action",
    cell: (row) => <OfferListTableAction offerPlanId={row.ticketOfferId} onDelete={handleDelete} />,
  },
];

  export const filtersData = [
    {
      name: "Choose Title",
      options: ["Adult", "Child"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
  ];